import { render, staticRenderFns } from "./AlarmRecordBuilding.vue?vue&type=template&id=1a19a2a0&"
import script from "./AlarmRecordBuilding.vue?vue&type=script&lang=js&"
export * from "./AlarmRecordBuilding.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRecordBuilding.vue?vue&type=style&index=0&id=1a19a2a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports